import mvFetch from './mvFetch'

const OKAY = 200
const NO_CONTENT = 204

function fetch(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'HEAD' | 'DELETE' | 'OPTIONS' = 'GET',
  body: string | null = null,
  manipulateRequestBeforeSend:
    | ((request: XMLHttpRequest) => void)
    | undefined = undefined
): Promise<XMLHttpRequest> {
  return new Promise((resolve, reject) => {
    function handleResponse() {
      try {
        if (
          (request.readyState === XMLHttpRequest.DONE &&
            request.status === OKAY) ||
          request.status === NO_CONTENT
        ) {
          resolve(request)
        } else {
          // There was a problem
          reject(request)
        }
      } catch (e) {
        // There was a problem
        reject(e)
      }
    }

    const request = new XMLHttpRequest()
    request.onloadend = handleResponse

    request.open(method, url)
    if (typeof manipulateRequestBeforeSend === 'function') {
      manipulateRequestBeforeSend(request)
    }
    request.send(body)
  })
}

/**
 * Makes an XMLHttpRequest and returns the results as a parsed JSON object.
 *
 * @param url - the requests's URL
 * @param [method] - the request's method, e.g.: GET, POST, PUT, etc. Default: GET
 * @param [body] - Body of the request. Default: null
 * @param [manipulateRequestBeforeSend] - This option function will be run between open()ing the request and send()ing it.
 * It gives you the opportunity to manipulate the XMLHttpRequest before it's sent to do things like setRequestHeader. Default: undefined
 */
async function fetchJson(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'HEAD' | 'DELETE' | 'OPTIONS' = 'GET',
  body: any = null,
  manipulateRequestBeforeSend:
    | ((request: XMLHttpRequest) => void)
    | undefined = undefined
): Promise<any> {
  return mvFetch
    .fetch(url, method, body, manipulateRequestBeforeSend)
    .then((response: XMLHttpRequest) => {
      const json = JSON.parse(response.responseText)
      return json
    })
}

export default { fetch, fetchJson }
